import * as actionTypes from '../../../constants/actionTypes'

export const emptyFields = () => (dispatch) => dispatch({ type: actionTypes.EMPTY_FIELDS })

export const setFields = (payload) => (dispatch) => dispatch({ type: actionTypes.SET_FIELDS, payload })